<template>
  <div class="cmpt-manufacture-edit-modal">
    <el-button type="primary" @click="openModal">编辑加工单</el-button>

    <el-dialog title="编辑加工单" :visible.sync="modalVisible" width="50%">
      <el-form inline :model="form">
        <div
          class="line item-box"
          v-for="(lineItem, lineItemIndex) in form.line_items"
          :key="lineItem.id"
        >
          <div class="label-text">
            {{ $get(lineItem, 'color_option_value.name', '') }}:{{ $get(lineItem, 'size_option_value.name', '') }}
          </div>

          <div
            class="manufacture item-box"
            v-for="(manufacture, manufactureIndex) in lineItem.manufactures"
            :key="manufacture.id"
          >
            <div class="label-text">{{ $get(manufacture, 'processing_plant.name', '') }}</div>

            <div
              class="raw item-box"
              v-for="raw in getRenderRaws(manufacture.raws)"
              :key="`raw-${raw.id}`"
            >
              <div class="flex content-between item-center">
                <div class="label-text">原料</div>
                <el-button
                  v-if="manufactureIndex === 0 && manufacture.raws.length > 1"
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                  @click="handleRawRemove(raw, manufacture.raws)"
                />
              </div>

              <el-form-item label="SKU">
                <el-select
                  v-model="raw.sku"
                  filterable
                  placeholder="请输入关键词"
                  remote
                  :remote-method="rawsRemoteMethod"
                  :disabled="checkRawsSkuDisabled(lineItem.manufactures, manufacture.id)"
                >
                  <el-option
                    v-for="sku in skus"
                    :key="sku.value"
                    :label="sku.label"
                    :value="sku.label"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="数量">
                <el-input v-model="raw.qty" :disabled="checkRawsSkuDisabled(lineItem.manufactures, manufacture.id)"/>
              </el-form-item>
            </div>

            <el-button
              v-if="manufactureIndex === 0"
              type="primary"
              icon="el-icon-plus"
              @click="handleRawAdd(manufacture.raws)"
            >
              添加原料
            </el-button>

            <div
              class="items item-box"
              v-for="(item, itemIndex) in manufacture.items"
              :key="`items-${item.id}`"
            >
              <div class="label-text">成品</div>

              <el-form-item label="SKU">
                <el-select
                  :value="item.sku"
                  @change="handleItemsSkuChange($event, lineItemIndex, manufactureIndex, itemIndex)"
                  filterable
                  placeholder="请输入关键词"
                  remote
                  :remote-method="itemsRemoteMethod"
                  :disabled="checkItemsSkuDisabled(lineItem.manufactures, manufacture.id)"
                >
                  <el-option
                    v-for="sku in skus"
                    :key="sku.value"
                    :label="sku.label"
                    :value="sku.label"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="数量">
                <el-input :value="item.qty" @input="handleItemsQtyChange($event, lineItemIndex, manufactureIndex, itemIndex)" />
              </el-form-item>

              <el-form-item label="加工费">
                <el-input v-model="item.processing_charges" />
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeModal">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
  import _ from 'lodash';

  @Component
  export default class ManufactureEditModal extends Vue {
    @Prop(Object) row

    form = {
      line_items: []
    }

    // 过滤已删除的原料
    getRenderRaws(raws) {
      return raws.filter(v => typeof v._destroy === 'undefined' || v._destroy !== true);
    }

    @Watch('modalVisible')
    initForm(newVisible, oldVisible) {
      if (oldVisible !== newVisible && newVisible) {
        this.form.line_items = _.cloneDeep(this.row.line_items);
      }
    }
    mounted() {
      this.initForm();
    }

    skus = []
    async fetchSkus(keyword) {
      const { data } = await this.$request.get('/materials/read_options', { per_page: 100, keyword });
      this.skus = data.map(v => ({ label: v.sku, value: v.id }));
    }
    rawsRemoteMethod(query) {
      if (!query) {
        this.skus = [];
      }

      this.fetchSkus(query);
    }
    itemsRemoteMethod(query) {
      if (!query) {
        this.skus = [];
      }

      this.fetchSkus(query);
    }
    handleItemsSkuChange(val, lineItemIndex, manufactureIndex, itemIndex) {
      const curManufacture = this.form.line_items[lineItemIndex].manufactures[manufactureIndex];
      this.$set(curManufacture.items[itemIndex], 'sku', val);

      // 下一道工序的原材料SKU是上一道工序的成品SKU
      const nextManufacture = this.form.line_items[lineItemIndex].manufactures[manufactureIndex + 1];
      if (typeof nextManufacture === 'undefined') {
        return;
      }
      this.$set(nextManufacture.raws[0], 'sku', val);
    }
    handleItemsQtyChange(val, lineItemIndex, manufactureIndex, itemIndex) {
      const curManufacture = this.form.line_items[lineItemIndex].manufactures[manufactureIndex];
      this.$set(curManufacture.items[itemIndex], 'qty', val);

      // 下一道工序的原材料数量是上一道工序的成品数量
      const nextManufacture = this.form.line_items[lineItemIndex].manufactures[manufactureIndex + 1];
      if (typeof nextManufacture === 'undefined') {
        return;
      }
      this.$set(nextManufacture.raws[0], 'qty', val);
    }

    // 第二道工序开始，原材料SKU禁止编辑
    checkRawsSkuDisabled(manufactures, curManufactureId) {
      const curManufactureIndex = manufactures.findIndex(v => curManufactureId === v.id);
      return curManufactureIndex !== 0;
    }
    // 第二道工序开始，原材料数量禁止编辑
    checkRawsQtyDisabled(manufactures, curManufactureId) {
      const curManufactureIndex = manufactures.findIndex(v => curManufactureId === v.id);
      return curManufactureIndex !== 0;
    }
    // 最后一道工序成品的SKU禁止编辑
    checkItemsSkuDisabled(manufactures, curManufactureId) {
      const curManufactureIndex = manufactures.findIndex(v => curManufactureId === v.id);
      return curManufactureIndex === (manufactures.length - 1);
    }

    handleRawAdd(raws) {
      raws.push({ id: `new-${Date.now()}` });
    }
    async handleRawRemove(raw, raws) {
      await this.$confirm('确定要删除?');
      if (typeof raw.id === 'string' && raw.id.startsWith('new-')) {
        const index = raws.findIndex(v => v.id === raw.id);
        raws.splice(index, 1);
      } else {
        this.$set(raw, '_destroy', true);
      }
    }

    modalVisible = false
    openModal() {
      this.modalVisible = true;
    }
    closeModal() {
      this.modalVisible = false;
    }

    async handleSubmit() {
      const lineItems = this.form.line_items.map(lineItem => {
        const manufactures = lineItem.manufactures.map(manufacture => {
          const items = manufacture.items.map(item => ({ id: item.id, sku: item.sku, qty: item.qty, processing_charges: item.processing_charges }));
          const raws = manufacture.raws.map(raw => {
            if (!_.hasIn(raw, '_destroy')) {
              if (typeof raw.id === 'string' && raw.id.startsWith('new-')) {
                return ({ sku: raw.sku, qty: raw.qty });
              }

              return ({ id: raw.id, sku: raw.sku, qty: raw.qty });
            }

            return ({ id: raw.id, sku: raw.sku, qty: raw.qty, _destroy: raw._destroy });
          });

          return { id: manufacture.id, items, raws };
        });

        return { id: lineItem.id, manufactures };
      });
      await this.$autoLoading(this.$request.put(`/orders/${this.row.id}/update_manufactures`, { line_items: lineItems }));
      this.closeModal();
      this.$emit('reload');
      this.$message.success(this.$t('operateSuccess'));
    }
  }
</script>

<style lang="scss" scoped>
  .item-box {
    padding: 10px;
    border: 1px solid #ddd;

    &:not(:last-child) {
      margin-bottom: 10px;
    }

    &.line {
      margin-left: 0;
    }
  }

  .label-text {
    font-weight: bold;
  }
</style>
